module.exports = __webpack_public_path__ + "static/media/baoji.a059070f.jpg";